import { Outlet } from "react-router-dom";
import "./styles.css";
import { Navbar } from "@/features/navbar/Navbar";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useAppShellController } from "./useAppShellController";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { LoadingSpinner } from "./components/LoadingSpinner";
import { ContentArea } from "./components/ContentArea";
import { MainContents } from "./components/MainContents";

/**
 * AppShell component that provides the main layout structure for the application
 * Includes navigation, error handling, and content area
 */
export const AppShell = () => {
  const controller = useAppShellController();

  if (controller.loading) {
    return <LoadingSpinner />;
  }

  return (
    <ErrorBoundary>
      <TooltipProvider>
        <div
          className="h-screen w-full flex overflow-hidden"
          id="app-container"
        >
          {/* Navbar with fixed position */}
          <div className="flex-shrink-0 h-full z-20">
            <Navbar />
          </div>

          {/* Main content area */}
          <MainContents>
            <ContentArea>
              <Outlet />
            </ContentArea>
          </MainContents>
        </div>
        <Toaster position="top-right" />
      </TooltipProvider>
    </ErrorBoundary>
  );
};
